import { render, staticRenderFns } from "./EmbedForm.vue?vue&type=template&id=a796ef0c&"
import script from "./EmbedForm.vue?vue&type=script&lang=js&"
export * from "./EmbedForm.vue?vue&type=script&lang=js&"
import style0 from "./EmbedForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports